import { Component, Input, OnInit } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { TestimonialService } from 'src/app/providers/testimonial/testimonial.service';
import { environment } from 'src/environments/environment';

@Component({
	selector: 'app-testimonial',
	templateUrl: './testimonial.component.html',
	styleUrls: ['./testimonial.component.scss']
})
export class TestimonialComponent implements OnInit {

	baseUrl: any;
	imagepath: any;
	testimonials: any = [];
	@Input() isWhiteText: boolean = true;
//   @Input() bannerClass: string = 'bannerdrk';


	desktopslider: OwlOptions = {
		loop: false,
		rewind: true,
		autoplay: true,
		autoplayTimeout: 10000,
		center: true,
		dots: true,
		autoHeight: false,
		autoWidth: true,
		// animateOut: 'fadeOut',
		// animateIn: 'fadeIn',
		smartSpeed: 1,
		responsive: {
			0: {
				items: 1,
			},
			600: {
				items: 1,
			},
			1000: {
				items: 1,
			}
		}
	}
	constructor(
		private testimonialService: TestimonialService,
	) {
		this.imagepath = environment.backendUrl + '/public/';
	}

	ngOnInit(): void {
		this.getTestimonial();
	}
	getTestimonial() {
		const obj = {};
		this.testimonialService.getTestimonialData(obj).subscribe(
			(response) => {
				if (response.code === 200 && response.testimonialData?.length > 0) {
					this.testimonials = response.testimonialData;
					// console.log(this.testimonials);

				} else {
					this.testimonials = []; // Fallback to an empty array if no testimonials found
				}
			},
			(error) => {
				console.error('Failed to fetch testimonial data', error);
				this.testimonials = []; // Error case fallback
			}
		);
	}
	isExpanded = false;

  // Toggle expand/collapse for a specific testimonial
  toggleText(testimonial: any) {
    testimonial.isExpanded = !testimonial.isExpanded;
  }
}
